import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import Layout from "../layout/mainLayout";
import SettingsLayout from "../layout/mainLayout/SettingsLayout";
import CourseView from "../pages/courses/CourseView";
import CurriculumBuilder from "../pages/curriculums/curriculumBuilder";
import { ManageQuestions } from "../pages/exams/ExamConfiguration/ExamPartDetails/ManageQuestions";
import Students from "../pages/masterData/Students";
import StudentView from "../pages/masterData/StudentView";
import ManageQuizQuestions from "../pages/quiz/Configuration/QuizDetails/ManageQuestions/ManageQuizQuestions";
import Discussion from "../pages/StudentsCorner/DiscussionForum/Discussion";
import { Permission } from "../utils/permissions";
import PageWithPermission from "./PageWithPermission";
import {
  AboutCourse,
  AboutCourseBundle,
  AddNoticeboard,
  AddQuestions,
  AssignmentDetails,
  Assignments,
  BundleQuiz,
  CourseBundleCourses,
  CourseBundleExams,
  CourseBundleView,
  CourseConfig,
  CourseEbooks,
  CourseExams,
  Courses,
  CoursesBundle,
  CurriculumEbooks,
  Curriculums,
  DiscussionForum,
  Districts,
  Doubts,
  EBooks,
  EBooksDetails,
  Exam,
  ExamDetails,
  ExaminationGuideline,
  ExaminationGuidelineTabs,
  ExamTimetable,
  GenerateQuestions,
  GrandTest,
  GrandTestView,
  ItiCenter,
  ItiCenterType,
  LiveSession,
  Login,
  Noticeboard,
  Questionbank,
  QuestionsPage,
  Quiz,
  QuizDetails,
  ResourceDetails,
  Resources,
  Roles,
  StudentsImport,
  StudyMaterialDetails,
  StudyMaterials,
  SuperGrandTest,
  SuperGrandTestView,
  TimeTableTabs,
  Trade,
  TradeTimeTable,
  TradeView,
  Users,
  ViewRole,
  YearPage,
} from "./routeImports";

interface PublicRouteProps {
  children: JSX.Element;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const isAuthenticate = localStorage.getItem("access_token");
  return isAuthenticate ? <Navigate to="/students/waiting" /> : children;
};

export const RoutesContainer = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="login" />} />
          <Route
            path="students/waiting"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_student_waiting_permissions_view
                }
              >
                <Students />
              </PageWithPermission>
            }
          />
          <Route
            path="students/rejected"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_student_rejected_permissions_view
                }
              >
                <Students />
              </PageWithPermission>
            }
          />
          <Route
            path="students/approved"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_student_approved_permissions_view
                }
              >
                <Students />
              </PageWithPermission>
            }
          />
          <Route
            path="students/import"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_student_waiting_permissions_import
                }
              >
                <StudentsImport />
              </PageWithPermission>
            }
          />

          <Route
            path="curriculums"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_curriculum_permissions_view}
              >
                <Curriculums />
              </PageWithPermission>
            }
          />
          <Route
            path="curriculums/:id"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_curriculum_permissions_view}
              >
                <CurriculumBuilder />
              </PageWithPermission>
            }
          />
          <Route
            path="curriculums/:id/e-books"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_curriculum_permissions_view}
              >
                <CurriculumEbooks />
              </PageWithPermission>
            }
          />
          <Route
            path="question-bank"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_questions_permissions_view}
              >
                <Questionbank />
              </PageWithPermission>
            }
          />
          <Route
            path="questions"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_questions_permissions_view}
              >
                <QuestionsPage />
              </PageWithPermission>
            }
          />
          {/* <Route
            path="question-bank/:id"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_questions_permissions_view}
              >
                <Questions />
              </PageWithPermission>
            }
          /> */}
          <Route
            path="e-books"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_ebook_permissions_view}
              >
                <EBooks />
              </PageWithPermission>
            }
          />
          <Route
            path="e-books/:id"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_ebook_permissions_view}
              >
                <EBooksDetails />
              </PageWithPermission>
            }
          />
          <Route
            path="study-material"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_study_material_permissions_view
                }
              >
                <StudyMaterials />
              </PageWithPermission>
            }
          />
          <Route
            path="study-material/:id"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_study_material_permissions_view
                }
              >
                <StudyMaterialDetails />
              </PageWithPermission>
            }
          />
          <Route
            path="resources"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_resource_permissions_view}
              >
                <Resources />
              </PageWithPermission>
            }
          />
          <Route
            path="resources/:id"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_resource_permissions_view}
              >
                <ResourceDetails />
              </PageWithPermission>
            }
          />
          <Route
            path="assignments"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_assignment_permissions_view}
              >
                <Assignments />
              </PageWithPermission>
            }
          />
          <Route
            path="assignments/:id"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_assignment_permissions_view}
              >
                <AssignmentDetails />
              </PageWithPermission>
            }
          />
          <Route
            path="students/:id"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_student_waiting_permissions_view
                }
              >
                <StudentView />
              </PageWithPermission>
            }
          />
          {/* <Route path="master-data/districts" element={<Districts />} />
          <Route
            path="master-data/iti-centre-type"
            element={<ItiCenterType />}
          />
          <Route path="master-data/bundle-types" element={<BundleQuiz />} />
          <Route path="master-data/trade" element={<Trade />} />
          <Route path="master-data/trade/:Tradeid" element={<Tradefeetime1 />} />
          <Route path="master-data/iti-centres" element={<ItiCenter />} />
          <Route path="master-data/users" element={<Users />} />
          <Route path="master-data/roles" element={<Roles />} />
          <Route path="master-data/year" element={<YearPage />} /> */}
          <Route
            path="/students-corner/trade-time-table"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_trade_time_table_permissions_view
                }
              >
                <TradeTimeTable />
              </PageWithPermission>
            }
          />
          <Route
            path="/students-corner/trade-time-table/:id"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_trade_time_table_permissions_view
                }
              >
                <TimeTableTabs />
              </PageWithPermission>
            }
          />
          <Route
            path="/students-corner/examination-guideline"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_examination_guideline_permissions_view
                }
              >
                <ExaminationGuideline />
              </PageWithPermission>
            }
          />
          <Route
            path="/students-corner/practical-slot"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_student_waiting_permissions_view
                }
              >
                <h1>This is practical-slot</h1>
              </PageWithPermission>
            }
          />
          <Route
            path="/students-corner/live-session"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_live_session_permissions_view}
              >
                <LiveSession />
              </PageWithPermission>
            }
          />
          <Route
            path="/students-corner/discussion-forum"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_discussion_forum_permissions_view
                }
              >
                <DiscussionForum />
              </PageWithPermission>
            }
          />
          <Route
            path="/students-corner/discussion-forum/:id"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_discussion_forum_permissions_view
                }
              >
                <Discussion />
              </PageWithPermission>
            }
          />

          <Route
            path="/students-corner/trade-time-table"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_trade_time_table_permissions_view
                }
              >
                <TradeTimeTable />
              </PageWithPermission>
            }
          />

          <Route
            path="/students-corner/examination-guideline"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_examination_guideline_permissions_view
                }
              >
                <ExaminationGuideline />
              </PageWithPermission>
            }
          />
          <Route
            path="/students-corner/examination-guideline/:id"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_examination_guideline_permissions_view
                }
              >
                <ExaminationGuidelineTabs />
              </PageWithPermission>
            }
          />
          <Route
            path="/students-corner/practical-slot"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_student_waiting_permissions_view
                }
              >
                <h1>This is practical-slot</h1>
              </PageWithPermission>
            }
          />
          <Route
            path="/students-corner/live-session"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_live_session_permissions_view}
              >
                <LiveSession />
              </PageWithPermission>
            }
          />
          <Route
            path="/students-corner/discussion-forum"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_discussion_forum_permissions_view
                }
              >
                <DiscussionForum />
              </PageWithPermission>
            }
          />
          <Route
            path="app/quiz"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_quiz_permissions_view}
              >
                <Quiz />
              </PageWithPermission>
            }
          />
          <Route
            path="app/quiz/:id"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_quiz_permissions_view}
              >
                <QuizDetails />
              </PageWithPermission>
            }
          />
          <Route
            path="app/quiz/:id/manage-questions"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_quiz_permissions_view}
              >
                <ManageQuizQuestions />
              </PageWithPermission>
            }
          />

          <Route
            path="app/exams"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_exam_permissions_view}
              >
                <Exam />
              </PageWithPermission>
            }
          />
          <Route
            path="app/exams/:id"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_exam_permissions_view}
              >
                <ExamDetails />
              </PageWithPermission>
            }
          />
          <Route
            path="app/exams/:id/manage-questions"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_exam_permissions_view}
              >
                <ManageQuestions />
              </PageWithPermission>
            }
          />
          <Route
            path="app/grand-test"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_grand_test_permissions_view}
              >
                <GrandTest />
              </PageWithPermission>
            }
          />
          <Route
            path="app/grand-test/:id"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_grand_test_permissions_view}
              >
                <GrandTestView />
              </PageWithPermission>
            }
          />
          <Route
            path="app/grand-test/:id/generate-questions"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_grand_test_permissions_view}
              >
                <GenerateQuestions />
              </PageWithPermission>
            }
          />
          <Route
            path="app/super-grand-test"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_super_grand_test_permissions_view
                }
              >
                <SuperGrandTest />
              </PageWithPermission>
            }
          />
          <Route
            path="app/super-grand-test/:id"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_super_grand_test_permissions_view
                }
              >
                <SuperGrandTestView />
              </PageWithPermission>
            }
          />
          <Route
            path="app/super-grand-test/:id/generate-questions"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_super_grand_test_permissions_view
                }
              >
                <AddQuestions />
              </PageWithPermission>
            }
          />
          <Route
            path="courses/all-courses"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_all_courses_permissions_view}
              >
                <Courses />
              </PageWithPermission>
            }
          />

          <Route
            path="courses/all-courses/:id"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_all_courses_permissions_view}
              >
                <CourseView />
              </PageWithPermission>
            }
          >
            <Route
              index
              element={
                <PageWithPermission
                  permissionKey={Permission.manage_all_courses_permissions_view}
                >
                  <Navigate to="about-course" />
                </PageWithPermission>
              }
            />
            <Route
              path="about-course"
              element={
                <PageWithPermission
                  permissionKey={Permission.manage_all_courses_permissions_view}
                >
                  <AboutCourse />
                </PageWithPermission>
              }
            />
            <Route
              path="configuration"
              element={
                <PageWithPermission
                  permissionKey={Permission.manage_all_courses_permissions_view}
                >
                  <CourseConfig />
                </PageWithPermission>
              }
            />
            <Route
              path="exams"
              element={
                <PageWithPermission
                  permissionKey={Permission.manage_all_courses_permissions_view}
                >
                  <CourseExams />
                </PageWithPermission>
              }
            />
            <Route
              path="e-books"
              element={
                <PageWithPermission
                  permissionKey={Permission.manage_all_courses_permissions_view}
                >
                  <CourseEbooks />
                </PageWithPermission>
              }
            />
          </Route>
          <Route
            path="courses/course-bundles"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_course_bundles_permissions_view
                }
              >
                <CoursesBundle />
              </PageWithPermission>
            }
          />
          <Route
            path="courses/course-bundles/:id"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_course_bundles_permissions_view
                }
              >
                <CourseBundleView />
              </PageWithPermission>
            }
          >
            <Route
              index
              element={
                <PageWithPermission
                  permissionKey={
                    Permission.manage_course_bundles_permissions_view
                  }
                >
                  <Navigate to="about-course-bundle" />
                </PageWithPermission>
              }
            />
            <Route
              path="about-course-bundle"
              element={
                <PageWithPermission
                  permissionKey={
                    Permission.manage_course_bundles_permissions_view
                  }
                >
                  <AboutCourseBundle />
                </PageWithPermission>
              }
            />
            <Route
              path="courses"
              element={
                <PageWithPermission
                  permissionKey={
                    Permission.manage_course_bundles_permissions_view
                  }
                >
                  <CourseBundleCourses />
                </PageWithPermission>
              }
            />
            <Route
              path="exams"
              element={
                <PageWithPermission
                  permissionKey={
                    Permission.manage_course_bundles_permissions_view
                  }
                >
                  <CourseBundleExams />
                </PageWithPermission>
              }
            />
            <Route
              path="e-books"
              element={<h1>E books component need to be written </h1>}
            />
          </Route>
        </Route>
        <Route path="/master-data" element={<SettingsLayout />}>
          <Route index element={<Navigate to="iti-centres" />} />
          <Route
            path="districts"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_district_permissions_view}
              >
                <Districts />
              </PageWithPermission>
            }
          />
          <Route
            path="iti-centre-type"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_center_type_permissions_view}
              >
                <ItiCenterType />
              </PageWithPermission>
            }
          />
          <Route
            path="bundle-types"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_bundle_type_permissions_view}
              >
                <BundleQuiz />
              </PageWithPermission>
            }
          />
          <Route
            path="trade"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_trade_permissions_view}
              >
                <Trade />
              </PageWithPermission>
            }
          />
          <Route
            path="trade/:Tradeid"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_trade_permissions_view}
              >
                <TradeView />
              </PageWithPermission>
            }
          />
          <Route
            path="iti-centres"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_iti_center_permissions_view}
              >
                <ItiCenter />
              </PageWithPermission>
            }
          />
          <Route
            path="users"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_user_permissions_view}
              >
                <Users />
              </PageWithPermission>
            }
          />
          <Route
            path="roles"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_role_permissions_view}
              >
                <Roles />
              </PageWithPermission>
            }
          />
          <Route
            path="roles/:id"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_role_permissions_view}
              >
                <ViewRole />
              </PageWithPermission>
            }
          />
          <Route
            path="year"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_year_permissions_view}
              >
                <YearPage />
              </PageWithPermission>
            }
          />
          <Route
            path="exam-timetable"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_exam_timetable_permissions_view
                }
              >
                <ExamTimetable />
              </PageWithPermission>
            }
          />
          <Route
            path="notice-board"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_notice_board_permissions_view}
              >
                <Noticeboard />
              </PageWithPermission>
            }
          />
          <Route
            path="doubts"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_doubt_permissions_view}
              >
                <Doubts />
              </PageWithPermission>
            }
          />
          <Route
            path="notice-board/add"
            element={
              <PageWithPermission
                permissionKey={
                  Permission.manage_notice_board_permissions_create
                }
              >
                <AddNoticeboard />
              </PageWithPermission>
            }
          />
          <Route
            path="notice-board/view/:noticeId"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_notice_board_permissions_edit}
              >
                <AddNoticeboard />
              </PageWithPermission>
            }
          />
          <Route
            path="notice-board/edit/:noticeId"
            element={
              <PageWithPermission
                permissionKey={Permission.manage_notice_board_permissions_edit}
              >
                <AddNoticeboard />
              </PageWithPermission>
            }
          />
        </Route>
        <Route
          path="login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
      </Routes>
    </Router>
  );
};
